import {FieldWrapper } from '@progress/kendo-react-form';
import React, { useState, useEffect } from 'react';
import FormContainer from '../components/FormContainer';
import config from '../appconfig/config.json';
import Loading from '../components/Loading';
import SubHeader from '../components/SubHeader';
import service from '../services/StatusEnquiryApiService'
import storage from '../factory/StorageFactory';
import CusHr from '../components/CusHr';
import StatusEnquiryDtls from '../components/StatusEnquiryDtls';
import CusBbox from '../components/CusBbox';
import CusGreenBtn from '../components/CusGreenBtn';

const ExpiredLoanOffer = (props) => {

    const [isLoading,setIsLoading] = useState(true);
    const [response,setResponse] = useState();

    useEffect(() => {
        console.log('@ExpiredLoanOffer useEffect');
        window.scrollTo(0, 0);
 
        clearData();

        getPropsData();
 
    }, []);
 
    const clearData = () => {
        if (storage.getStateId() !== null) {
            storage.clearAll();
        }
    }
 
    const getPropsData = () => {
        if (props.location.state !== undefined) { //not first time
         
            let uen = props.location.state.uen;
            let idNo = props.location.state.idNum;
             
            getStatus(uen,idNo)
        }
        else {
            console.log('err: uen and idno not found');
        }
    }

    const getStatus = (uen,ic) => {
        service.getStatus(uen,ic).then( res => {
            setResponse(res.data);
            setIsLoading(false);
        })
        .catch( err => {
            console.log('err: ',err);
            setIsLoading(false);
        })
    }

    const handleOnclick = (e) => {

    }
     

    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <div className="container-fluid">
        <SubHeader title={'Oops!'} />  
        <FormContainer>
            <div style={{ padding: '20px' }}>
                <div>{'Your letter of Offer has expired. Do reapply again.'}</div>
            </div>
            <CusHr  style={{ marginTop: '-2em' }} />

            <StatusEnquiryDtls data={response.StatusDtls} />              

            <CusHr style={{ marginTop: '-2em' }} />

            <CusBbox id1="interestRate" lb1="Interest Rate (Indicative)" val1={response.StatusDtls.InterestRate}
                id2="instalment" lb2="Instalment (Indicative)" val2={response.StatusDtls.Instalment} />

            <br/>
            <CusGreenBtn lbtxt={'Reapply SME e-Financing'} onClick={handleOnclick}  />

            <br/>
        </FormContainer>
     
         <br />
        </div>
    )
}

export default ExpiredLoanOffer;